import { gql } from '@/gql';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useToast } from '@chakra-ui/react';

import { queryAutomationGroups } from './useFetchAutomationGroups';

export const deleteAutomationGroupMutation = gql(`#graphql
  mutation DeleteAutomationGroup($input: GroupsDeleteInput!) {
    deleteAutomationGroup(input: $input) {
      automationGroup {
        id
        name
        position
        deletedAt
        createdAt
        updatedAt
      }
    }
  }
`);

export const useDeleteAutomationGroup = () => {
  const { t } = useTranslation();
  const toast = useToast();
  return useMutation(deleteAutomationGroupMutation, {
    refetchQueries: [queryAutomationGroups],
    awaitRefetchQueries: true,
    onCompleted(data) {
      if (data.deleteAutomationGroup?.automationGroup) {
        toast({
          title: t('toast_messages.group_deleted'),
          status: 'success',
        });
      }
    },
  });
}
